/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const atsJobDetailSchema = z.enum(['title', 'location', 'description'])

export type AtsJobDetailSchema = z.infer<typeof atsJobDetailSchema>
